import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "address-book",
  "use": "address-book-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"address-book\"><path d=\"M96 0v512h384V0H96zm192 128.165c35.255 0 63.835 28.58 63.835 63.835s-28.58 63.835-63.835 63.835-63.835-28.58-63.835-63.835 28.58-63.835 63.835-63.835zM384 384H192v-32c0-35.348 28.653-64 64-64h64c35.348 0 64 28.652 64 64v32zM32 32h48v96H32V32zM32 160h48v96H32v-96zM32 288h48v96H32v-96zM32 416h48v96H32v-96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/address-book.svg
// module id = UagB
// module chunks = 1